export const Settings = (settings) => ({
    settings,

    all: function() {
        return this.settings;
    },

    get: function(name, defaultValue = null) {
        const setting = this.settings.find(s => s.name === name);
        return setting ? setting.value : defaultValue;
    },

});

